/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
import { SearchCriteria } from "./SearchCriteria";
import { SortCriteriaList } from "./SortCriteriaList";
import { SerdesUtils } from "@amzn/coral-typescript-types-pieces";
import { CoralModel, modelRegistrySingleton, } from "@amzn/ihm-js-coral-client";
/**
 * <pre><code>Input for SearchReports API
 *
 * term, reportType - reprsents the Term and Report Type for which reports need to be fetched. Each Term can own
 * multiple report types.
 * Example -  Term: SP_INVOICE_MANAGEMENT owns Report Types : INVOICE_RECONCILIATION_FILES, INVOICE_DISUPTE_FILES
 *
 * lpAttributesKey - Reports can be mapped at attributes related to logistics party. This is a optional field used
 * to fetch reports at attribute level granularity.
 * Example - LP1 + SCAC1, LP1 + SCAC2 have different reports mapped.
 *
 * pageSize - represents number of reports to be fetched in a page
 * pageId - represents identifier of the page to be fetched. If pageId is null, the first page is fetched.
 * offset - specifies number of records to be skipped for paginated results
 *
 * searchCriteria - Represents serach criteria for reports
 * sortCriteriaList - Specifies the sorting criteria for the reports obtained, allows results to be sorted on
 * multiple fields. If not provided, reports fetched does not follow any specific order. Currently supporting
 * sort only on single criteria
 * <\/code><\/pre>
 **/
export class SearchReportsInput extends CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the SearchReportsInput#clone(obj: PlainObjectFrom<SearchReportsInput>) method.
     */
    constructor(__pageSize, __reportType, __term, __customerId, __logisticsPartyId, __lpAttributesKey, __offset, __pageId, __partnerAccountId, __searchCriteria, __sortCriteriaList, __userSessionAttributes) {
        super();
        this.pageSize = __pageSize;
        this.reportType = __reportType;
        this.term = __term;
        this.customerId = __customerId;
        this.logisticsPartyId = __logisticsPartyId;
        this.lpAttributesKey = __lpAttributesKey;
        this.offset = __offset;
        this.pageId = __pageId;
        this.partnerAccountId = __partnerAccountId;
        this.searchCriteria = __searchCriteria;
        this.sortCriteriaList = __sortCriteriaList;
        this.userSessionAttributes = __userSessionAttributes;
    }
    /**
     * Create a shallow clone of SearchReportsInput from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */
    static clone(obj) {
        return new SearchReportsInput(obj.pageSize, obj.reportType, obj.term, obj.customerId, obj.logisticsPartyId, obj.lpAttributesKey, obj.offset, obj.pageId, obj.partnerAccountId, obj.searchCriteria, obj.sortCriteriaList, obj.userSessionAttributes);
    }
    static fromJson(data) {
        return new SearchReportsInput(SerdesUtils.identityFunction(data.pageSize), SerdesUtils.identityFunction(data.reportType), SerdesUtils.identityFunction(data.term), (($$val) => $$val == undefined ? undefined : SerdesUtils.identityFunction($$val))(data.customerId), (($$val) => $$val == undefined ? undefined : SerdesUtils.identityFunction($$val))(data.logisticsPartyId), (($$val) => $$val == undefined ? undefined : SerdesUtils.identityFunction($$val))(data.lpAttributesKey), (($$val) => $$val == undefined ? undefined : SerdesUtils.identityFunction($$val))(data.offset), (($$val) => $$val == undefined ? undefined : SerdesUtils.identityFunction($$val))(data.pageId), (($$val) => $$val == undefined ? undefined : SerdesUtils.identityFunction($$val))(data.partnerAccountId), (($$val) => $$val == undefined ? undefined : SearchCriteria.fromJson($$val))(data.searchCriteria), (($$val) => $$val == undefined ? undefined : SortCriteriaList.fromJson($$val))(data.sortCriteriaList), (($$val) => $$val == undefined ? undefined : SerdesUtils.identityFunction($$val))(data.userSessionAttributes));
    }
    static toJson(data) {
        return Object.assign({
            pageSize: SerdesUtils.identityFunction(data.pageSize),
            reportType: SerdesUtils.identityFunction(data.reportType),
            term: SerdesUtils.identityFunction(data.term),
            customerId: (($$val) => $$val == undefined ? null : SerdesUtils.identityFunction($$val))(data.customerId),
            logisticsPartyId: (($$val) => $$val == undefined ? null : SerdesUtils.identityFunction($$val))(data.logisticsPartyId),
            lpAttributesKey: (($$val) => $$val == undefined ? null : SerdesUtils.identityFunction($$val))(data.lpAttributesKey),
            offset: (($$val) => $$val == undefined ? null : SerdesUtils.identityFunction($$val))(data.offset),
            pageId: (($$val) => $$val == undefined ? null : SerdesUtils.identityFunction($$val))(data.pageId),
            partnerAccountId: (($$val) => $$val == undefined ? null : SerdesUtils.identityFunction($$val))(data.partnerAccountId),
            searchCriteria: (($$val) => $$val == undefined ? null : SearchCriteria.toJson($$val))(data.searchCriteria),
            sortCriteriaList: (($$val) => $$val == undefined ? null : SortCriteriaList.toJson($$val))(data.sortCriteriaList),
            userSessionAttributes: (($$val) => $$val == undefined ? null : SerdesUtils.identityFunction($$val))(data.userSessionAttributes),
        });
    }
}
SearchReportsInput.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#SearchReportsInput";
// Register concrete types for serialization/deserialization
modelRegistrySingleton.registerType(SearchReportsInput);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [SearchReportsInput] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */
export function validateSearchreportsinput(data) {
    // TODO: Actually implement this!
    return data;
}
